import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@shared/api/baseQuery";
import { configApi } from "@shared/lib/configApi";
import {
    PublicCompanyProfile,
    PublicCompanyProfileResponse,
    PublicCompanyProfileShort,
    PublicCompanyProfileShortResponse,
    PublicProfile,
    PublicProfileResponse
} from "./types";

export const publicProfileApi = createApi({
    reducerPath: "publicProfileApi",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getPublicProfileById: builder.query<PublicProfile, string>({
            query: (uuid) => ({ url: `${configApi.API_URL}/v1/profiles/${uuid}` }),
            transformResponse: (response: PublicProfileResponse) => response.data
        }),
        getPublicCompanyProfileShortById: builder.query<PublicCompanyProfileShort, string>({
            query: (uuid) => ({
                url: `${configApi.API_URL}/v1/company/profiles/${uuid}/public?fields=name,logoUrl,isVerified`
            }),
            transformResponse: (response: PublicCompanyProfileShortResponse) => response.data
        }),
        getPublicCompanyProfileById: builder.query<PublicCompanyProfile, string>({
            query: (uuid) => ({
                url: `${configApi.API_URL}/v1/company/profiles/${uuid}/public`
            }),
            transformResponse: (response: PublicCompanyProfileResponse) => response.data
        })
    })
});